import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import AlertElement from './UI/Alert/Alert';
import "./Users.css";
import axios from 'axios';

export class Statistics extends Component {
    displayName = Statistics.name
    constructor(props) {
        super(props);
        this.state = {
            forecastsUsers: [],
            forecastsDays: [],
            loadingUsers: false,
            loadingDays: false,
            showmodal: false,
            classMessageTitle: 'alert-primary',
            showmodalform: false,
            modaltitle: '',
            modalbody: '',
            orderType: 'name',
            orderDirection: true,
            formsconfig:
            {
                show: false,
                type: 0,
            },
            filterform: {
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Nome o Matricola'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                }
            },
            formIsValid: false,
        };
        this.filterCustom = this.filterCustom.bind(this);
        //this.refresh();
    }
    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
        })
        axios.post('api/Statistics/ListDays', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecastsDays: respose.data, loadingDays: false });
            })
            .catch(data => {
            });
        axios.post('api/User/ListStatistics', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecastsUsers: respose.data, loadingUsers: false });
                this.orderCustom(respose.data);
            })
            .catch(data => {
            });

    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    filterCustom(value) {
        var result_matricola = true;
        var result_name = true;
        result_matricola &= (this.state.filterform.matricola.value === '' || value.matricola.toUpperCase().includes(this.state.filterform.matricola.value.toUpperCase()));
        result_name &= (this.state.filterform.matricola.value === '' || value.name.toUpperCase().includes(this.state.filterform.matricola.value.toUpperCase()));
        return result_matricola || result_name;
    }
    orderCustom(array) {
        var direction;
        if (this.state.orderDirection === true)
            direction = -1;
        else
            direction = 1;
        if (this.state.orderType === 'name') {
            return array.sort((a, b) => (a.name > b.name) ? direction : -direction)
        } else if (this.state.orderType === 'matricola') {
            return array.sort((a, b) => (a.matricola > b.matricola) ? direction : -direction)
        } else if (this.state.orderType === 'totale_transazioni') {
            return array.sort((a, b) => (a.totale_transazioni > b.totale_transazioni) ? direction : -direction)
        } else if (this.state.orderType === 'accrediti_euronet') {
            return array.sort((a, b) => (a.accrediti_euronet > b.accrediti_euronet) ? direction : -direction)
        } else if (this.state.orderType === 'accrediti_bonifici') {
            return array.sort((a, b) => (a.accrediti_bonifici > b.accrediti_bonifici) ? direction : -direction)
        } else if (this.state.orderType === 'accrediti_diretti') {
            return array.sort((a, b) => (a.accrediti_diretti > b.accrediti_diretti) ? direction : -direction)
        } else if (this.state.orderType === 'non_accreditato') {
            return array.sort((a, b) => (a.non_accreditato > b.non_accreditato) ? direction : -direction)
        }
    }
    orderFunction = (event, newtype) => {
        if (newtype === this.state.orderType) { this.state.orderDirection = !this.state.orderDirection }
        this.state.orderType = newtype;
        this.orderCustom(this.state.forecastsUsers);
        //this.forceRender();
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    inputFilterHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.filterform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedForm[inputIdentifier] = updatedFormElement;
        this.setState({ filterform: updatedForm });
        //this.forceRender();
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }
    static renderTableUsers(forecasts, filterCustom, orderDirection, orderFunction) {
        return (
            <div className="reducepadding tableFixHead">
                <table className='table responsive-table'>
                    <thead>
                        <tr>
                            <th className="col-xs-2">Matricola{(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'matricola')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'matricola')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">&euro; Totale   {(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'totale_transazioni')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'totale_transazioni')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">&euro; Euronet  {(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'accrediti_euronet')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'accrediti_euronet')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">&euro; Bonifici {(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'accrediti_bonifici')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'accrediti_bonifici')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">&euro; Diretti  {(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'accrediti_diretti')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'accrediti_diretti')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">&euro; Giacenza {(orderDirection === false) && <a onClick={(event) => orderFunction(event, 'non_accreditato')}><Glyphicon glyph='sort-by-attributes-alt' /></a>}{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'non_accreditato')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            forecasts.filter(filterCustom)
                                .map(forecast =>
                                    <tr key={forecast.id} className={" " + (forecast.bancomat_accredito === 99 ? 'tr-disabled' : '') + (forecast.bancomat_accredito === 98 ? 'tr-notconfigured' : '')}>
                                        <td>{forecast.matricola}</td>
										<td>{(Math.round(forecast.totale_transazioni * 100) / 100).toFixed(2)} EUR</td>
                                        <td>{(Math.round(forecast.accrediti_euronet * 100) / 100).toFixed(2)} EUR</td>
                                        <td>{(Math.round(forecast.accrediti_bonifici * 100) / 100).toFixed(2)} EUR ({forecast.nbonifici})</td>
                                        <td>{(Math.round(forecast.accrediti_diretti * 100) / 100).toFixed(2)} EUR</td>
                                        <td>{(Math.round(forecast.non_accreditato * 100) / 100).toFixed(2)} EUR</td>
                                    </tr>
                                )}
                    </tbody>
                </table>
            </div>
        );
    }
    static renderTableDays(forecasts, filterCustom, orderDirection, orderFunction) {
        return (
            <div className="reducepadding tableFixHead">
                <table className='table responsive-table'>
                    <thead>
                        <tr>
                            <th className="col-xs-2">Giorno</th>
                            <th className="col-xs-2">Numero Transazioni</th>
                            <th className="col-xs-2">Totale Euro</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            forecasts.map(forecast =>
                                    <tr>
                                        <td>{forecast.giorno}</td>
                                        <td>{forecast.numTransazioni}</td>
                                        <td>{(Math.round(forecast.amount * 100) / 100).toFixed(2)} EUR</td>
                                    </tr>
                                )}
                    </tbody>
                </table>
            </div>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div className="reducepadding">
                <form>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={this.state.formsconfig.type === 3 ? true : false} />
                    ))}
                </form>
            </div>
        );
        const filterElementsArray = [];
        for (let key in this.state.filterform) {
            filterElementsArray.push({
                id: key,
                config: this.state.filterform[key]
            });
        }
        let filterUsers = (
            <div className="row">
                {filterElementsArray.map(formElement => (
                    <div className="col-sm-3" key={'div' + formElement.id}>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputFilterHandler(event, formElement.id)}
                            textdisabled={false} />
                    </div>
                ))}
            </div>
        );
        let statDays = (
            <div className="row">
                {filterElementsArray.map(formElement => (
                    <div className="col-sm-3" key={'div' + formElement.id}>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputFilterHandler(event, formElement.id)}
                            textdisabled={false} />
                    </div>
                ))}
            </div>
        );
        let contentsUsers = this.state.loadingUsers
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : Statistics.renderTableUsers(this.state.forecastsUsers, this.filterCustom, this.state.orderDirection, this.orderFunction);

        let contentsDays = this.state.loadingDays
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : Statistics.renderTableDays(this.state.forecastsDays, this.filterCustom, this.state.orderDirection, this.orderFunction);

        return (
            <div className="reducepadding">
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <div className="row">
                    <div className="col-sm-9"> <h1>Statistiche</h1> </div>
                    {contentsDays}
                    {filterUsers}
                </div>
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
                <span></span>
                {contentsUsers}
            </div>
        );
    }
}
